import { buildLink, RouteSlotInput, SearchPage } from '@luks/ui';
import { useQuery } from 'react-query';

export type Suggestions = Array<{
  categoryName: string;
  moreUrl?: string;
  results: Array<{
    url: string;
    data: string;
  }>;
}>;

type MappedSuggestions = Exclude<
  RouteSlotInput<typeof SearchPage, 'header'>,
  Function
>['suggestions'];

export function useSearchSuggestions(query?: string): {
  status: number;
  suggestions: MappedSuggestions;
} {
  const { data, isFetching, isLoading, isRefetching } = useQuery<Suggestions>(
    ['search.suggestions', query],
    async ({ queryKey }) => {
      const [, query] = queryKey;
      return await (
        await fetch(`/fastsolr/solr-search.php?query=${query}`)
      ).json();
    },
    {
      enabled: !!query && query.length > 0,
    },
  );
  const status = isFetching || isLoading || isRefetching ? 102 : 200;
  const suggestions: MappedSuggestions = (data || []).map((category) => ({
    id: category.categoryName,
    categoryName: category.categoryName,
    shouldBeLinked: !!category.moreUrl,
    results: category.results.map((res, index) => ({
      id: `${category.categoryName}-${index}`,
      title: res.data,
      Target: buildLink({ href: res.url }),
    })),
  }));
  return { status, suggestions };
}
